import React from 'react';
import styled from 'styled-components';
import { Button, List } from 'components';
import { Template } from 'api/TemplateController';
import TemplateListCell, { TemplateListCellAuth } from './TemplateListCell';

export interface TemplateListProps {
  items: Template[];
  selected?: string;
  onChangeSelection: (id: string) => void;
  auth: TemplateListCellAuth;
  loadMoreTemplates: () => void;
  loading: boolean;
  hasMore: boolean;
}

const StyledLoadMore = styled.div`
  text-align: center;
`;

const TemplateList = (props: TemplateListProps) => {
  const {
    items,
    selected,
    onChangeSelection,
    auth,
    loadMoreTemplates,
    loading,
    hasMore,
  } = props;

  const loadMore = React.useMemo(
    () => (
      <StyledLoadMore>
        <Button
          onClick={loadMoreTemplates}
          disabled={!hasMore || loading}
          loading={loading}
        >
          {hasMore ? 'Load More' : 'No More Templates'}
        </Button>
      </StyledLoadMore>
    ),
    [hasMore, loading, loadMoreTemplates],
  );

  return (
    <StyledList loading={loading} loadMore={loadMore}>
      {items?.map(template => (
        <TemplateListCell
          key={template.id}
          template={template}
          selected={template.id === selected}
          onClick={() => onChangeSelection(template.id)}
          auth={auth}
          dataCy={`template-list-item-${template.id}`}
        />
      ))}
    </StyledList>
  );
};

export default TemplateList;

const StyledList = styled(List)`
  /* Somewhat bad way to fill the window height */
  height: calc(100% - 102px);
  overflow-y: scroll;
`;
